import { VariaveisAmbiente } from 'config';
import { AmbienteSistemaModel } from 'model/api/gestao/ambiente-sistema/ambiente-sistema-model';
import { ApiListModel } from 'model/api/gestao/api-list-model/api-list-model';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';

export function useGetAmbienteSistemas() {
    const { invocarApi, ...outrasPropriedades } = useApiBase<ApiListModel<AmbienteSistemaModel>>();

    const getAmbienteSistemas = useCallback(
        (sistemaId: string, newPage: number, query?: string) =>
            invocarApi({
                url: `${VariaveisAmbiente.apiVersion}/sistema/${sistemaId}/ambiente?page=${newPage}&${query}`,
                method: 'GET',
                enviarTokenUsuario: true
            }),
        [invocarApi],
    );
    return {
        ...outrasPropriedades,
        getAmbienteSistemas,
    };
}
